import React from 'react'
import Image from 'next/image'
import styles from "./Pillar.module.scss"

export default function Pillar({ item }) {
  return (
    <div className={styles.pillarParent}>
      <div>
        <Image
          className={styles.pillarImage}
          src={item.img}
          alt={item.title}
          width={50}
          height={50}
        />
        <h3 className={styles.pillarTitle} style={{ marginBottom: ".5rem" }}>
          {item.title}
        </h3>
      </div>
      <p className={styles.pillarBody}>{item.desc}</p>
    </div>
  )
}